/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_cognito_identity_pool_id": "us-west-1:67a59fbb-0684-4ad6-a3a9-f762edde42e4",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_oLLYh6IOx",
    "aws_user_pools_web_client_id": "7eae2a0hdh3s07f6v3r71jprad",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "landingpage145035-staging",
    "aws_user_files_s3_bucket_region": "us-west-1"
};


export default awsmobile;
